$(document).ready(function() {
  $('.product-faq .faq-question').on('click', function() {
    const $item = $(this).closest('.faq-item');
    const $answer = $item.find('.faq-answer');

    if ($item.hasClass('active')) {
      // Close current
      $item.removeClass('active');
      $answer.stop().slideUp(300);
    } else {
      // Close all others
      $('.product-faq .faq-item.active').removeClass('active')
        .find('.faq-answer').stop().slideUp(300);

      // Open current
      $item.addClass('active');
      $answer.stop().slideDown(300);
    }
  });

  // Ensure all answers hidden initially
  $('.product-faq .faq-answer').hide();
});
